import { CustomTenantModel, TenantActions } from 'src/providers/Tenant/Tenant.types';
import { useTenantContext } from 'src/providers/Tenant/TenantContext';
import { bpeConfig } from '@enterprise/common';

export function useTenantCode(): string {
  return useTenantContext().tenantCode ?? bpeConfig.tenant.code;
}

export function useTenantLoading(): boolean {
  return useTenantContext().loading;
}

export function useTenantConfig(): CustomTenantModel | undefined {
  return useTenantContext().tenant;
}

export function useTenantLocale(): string {
  return useTenantConfig()?.locale ?? 'en-US';
}

export function useTenantActions(): TenantActions {
  return useTenantContext().actions;
}
